import {
  Directive,
  EmbeddedViewRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef
} from "@angular/core";
import { takeUntil } from "rxjs/operators";

import { AuthService } from "@lantern/app/core/auth";

@Directive({
  selector: "[taAuthIf]"
})
export class AuthIfDirective implements OnInit, OnDestroy {
  static ngIfUseIfTypeGuard: void;

  @Input()
  set taAuthIf(permission: string | undefined) {
    this.permission = permission;
    this.updateView();
  }

  @Input()
  set taAuthIfElse(elseTemplateRef: TemplateRef<any>) {
    this.elseTemplateRef = elseTemplateRef;
    this.elseViewRef = undefined;
    this.updateView();
  }

  private permission?: string;
  private elseTemplateRef?: TemplateRef<any>;
  private thenViewRef?: EmbeddedViewRef<any>;
  private elseViewRef?: EmbeddedViewRef<any>;
  private onDestroyEmitter = new EventEmitter<void>();

  constructor(
    private auth: AuthService,
    private viewContainer: ViewContainerRef,
    private thenTemplateRef: TemplateRef<any>
  ) {}

  ngOnInit(): void {
    this.auth.onInitialized
      .pipe(
        takeUntil(this.onDestroyEmitter)
      )
      .subscribe(() => {
        this.updateView();
      });
  }

  ngOnDestroy(): void {
    this.onDestroyEmitter.emit();
    this.onDestroyEmitter.complete();
  }

  private updateView(): void {
    if (this.visibleViewRef == null) {
      this.clearViewContainer();
      this.createVisibleViewRef();
    }
  }

  private clearViewContainer(): void {
    this.viewContainer.clear();
    this.thenViewRef = undefined;
    this.elseViewRef = undefined;
  }

  private createVisibleViewRef(): void {
    if (this.visibleTemplateRef) {
      this.visibleViewRef = this.viewContainer.createEmbeddedView(
        this.visibleTemplateRef
      );
    }
  }

  private get hasPermission(): boolean {
    return this.auth.hasPermission(this.permission);
  }

  private get visibleViewRef(): EmbeddedViewRef<any> | undefined {
    return this.hasPermission ? this.thenViewRef : this.elseViewRef;
  }

  private set visibleViewRef(value: EmbeddedViewRef<any> | undefined) {
    if (this.hasPermission) {
      this.thenViewRef = value;
    } else {
      this.elseViewRef = value;
    }
  }

  private get visibleTemplateRef(): TemplateRef<any> | undefined {
    return this.hasPermission ? this.thenTemplateRef : this.elseTemplateRef;
  }

}
